import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Icon, Divider } from 'semantic-ui-react';
import { Flex, Box } from 'rebass';
import { ExamReq, ScoreBoxList, ScoreBox, Text } from '@tcaster/tcaster-web-lib';
import { COLOR, FONT_SIZE } from '@tcaster/tcaster-theme';
import styled from 'styled-components';

import ExamScore from '../ExamScore';
import { ExamScoreHeader } from '../../Components/ExamScore';

const NegMarginDev = styled.div`
  margin-top: -0.4em;
  margin-bottom: 1em;
`;

const GREEN_SCORE = '#48b6a3';

const SAccordion = styled(Accordion)`
  &.ui.accordion .accordion .title .dropdown.icon,
  &.ui.accordion .title .dropdown.icon {
    color: ${GREEN_SCORE};
  }
`;

const ToggleAccordianScore = styled(Text)`
  color: ${GREEN_SCORE};
  flex: 1 1 auto;
  &:hover {
    text-decoration: underline;
  }
`;

const examConverter = (exam = {}) => ({
  subject: exam.examsDisplay,
  percent: exam.weightPercent ? `${exam.weightPercent}%` : 'ใช้พิจารณา',
  conditions: exam.examsSubDisplay,
});
class ExamRequires extends Component {
  state = {
    showRequiredList: this.props.initialShowRequiredList,
  };
  handleAccordionClick = (e, titleProps) => {
    this.setState(prevProps => ({ showRequiredList: !prevProps.showRequiredList }));
  };
  render() {
    const { title, subTitle, exams, scores, examsSpec, enableScoreCalc, scoresList } = this.props;
    const { showRequiredList } = this.state;
    return (
      <Flex flexDirection="column">
        <ExamScore
          rules={exams}
          additionalRules={examsSpec}
          enableScoreCalc={enableScoreCalc && examsSpec.canCalculate}
          render={scoreProps => (
            <ExamScoreHeader
              title={title}
              subTitle={subTitle}
              {...scoreProps}
              precision={examsSpec ? examsSpec.decimalPoint : null}
            />
          )}
        />
        {scores && scores.length === 3 && (
          <Box my={1}>
            <ScoreBoxList scores={scores} />
          </Box>
        )}
        {scoresList &&
          scoresList.length >= 0 &&
          scoresList.map((scores, index) => (
            <Box key={index} my={1}>
              <ScoreBoxList scores={scores} />
            </Box>
          ))}
        <Box mt={2} />
        <SAccordion>
          <Divider fitted />
          <Accordion.Title active={showRequiredList} onClick={this.handleAccordionClick}>
            <Flex flexDirection="row" alignItems="center">
              <Icon name="dropdown" />
              <ToggleAccordianScore fontWeight="200">ดูสัดส่วนคะแนน</ToggleAccordianScore>
            </Flex>
          </Accordion.Title>
          <Accordion.Content active={showRequiredList}>
            {exams.length > 0 && <ExamReq reqs={exams.map(examConverter)} />}
          </Accordion.Content>
          <Divider fitted />
        </SAccordion>
      </Flex>
    );
  }
}

ExamRequires.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  exams: PropTypes.arrayOf(PropTypes.shape({})),
  scores: PropTypes.arrayOf(
    PropTypes.shape({
      score: PropTypes.number,
      scoreLabel: PropTypes.string,
      type: PropTypes.oneOf(['ADMISSION', 'MEDS']),
    }),
  ),
  initialShowRequiredList: PropTypes.bool,
};

ExamRequires.defaultProps = {
  initialShowRequiredList: false,
};

export default ExamRequires;
